"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ARTWORK_VIEW_URL = exports.MAIN_PAGE_URL = void 0;
exports.MAIN_PAGE_URL = 'https://mixtiles.com';
exports.ARTWORK_VIEW_URL = '/art/artwork/:category/:artworkId';
//# sourceMappingURL=paths.js.map